import React from 'react';
import { connect } from '@cerebral/react';
import { state, signal } from 'cerebral/tags';

import PartsOverview from '../components/PartsOverview';

const setDisabledParts = (parts, answers) => parts.map((p) => {
    if (answers[p.slug]) {
        return {
            ...p,
            disabled: Object.keys(answers[p.slug]).length >= p.sections
                .filter(s => s.overview !== true)
                .filter(s => !s.optional)
                .length,
        };
    }

    return {
        ...p,
        disabled: false,
    };
});

const PartsOverviewContainer = ({ screens, setNotification, ...props }) => (
    <PartsOverview
        {...screens.main}
        {...props}
        parts={setDisabledParts(props.parts, props.answers)}
        closeNotification={() => {
            setNotification({
                notification: null,
            });
        }}
    />
);

const stateSignals = {
    answers: state`app.answers`,
    screens: state`app.data.screens`,
    parts: state`app.data.parts`,
    notification: state`app.notification`,
    setNotification: signal`app.setNotification`,
    loading: state`app.loading`,
    continueURL: state`app.continueURL`,
};

export default connect(
    stateSignals,
    PartsOverviewContainer
);



// WEBPACK FOOTER //
// ./src/containers/PartsOverview.js